import React, { useState, useEffect } from "react";
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import Select from "react-select";
import { toast } from "react-toastify";
import DropdownWithCustomValuesModal from "../../components/DropdownWithCustomValuesModal";
import { get, post } from "../../services/api";
import { useSearchParams, useNavigate } from "react-router-dom";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import PhoneInput from "react-phone-number-input";
import "./Franchise.css";
import { TextField } from "@mui/material";

function FranchiseOnboardingForm() {
  const [activeTab, setActiveTab] = useState("franchise");
  const [loading, setLoading] = useState(false);
  const [nextFranchiseCode, setNextFranchiseCode] = useState("");
  const [currentFranchiseId, setCurrentFranchiseId] = useState(0);
  const [isUnderReview, setIsUnderReview] = useState(false);
  const [isFinallyCompleted, setIsFinallyCompleted] = useState(false);
  const [stepSavingStates, setStepSavingStates] = useState({
    franchise: false,
    partners: false,
    campus: false,
    payment: false,
    salesperson: false,
    attachments: false,
  });

  const token = localStorage.getItem("token");
  const user = localStorage.getItem("userId");
  const organizationId = localStorage.getItem("organizationId");
  const [searchParams] = useSearchParams();
  const mode = searchParams.get("mode") || "new";
  const franchiseIdFromUrl = searchParams.get("franchiseId");
  const [isEditMode, setIsEditMode] = useState(mode === "edit");
  const [regionData, setRegionData] = useState([]);
  const [cityData, setCityData] = useState([]);
  const [schoolCategoryData, setSchoolCategoryData] = useState([]);
  const [isModalVisible, setModalVisible] = useState(false);
  const [modalModuleName, setModalModuleName] = useState("");
  const [showCollaboration, setShowCollaboration] = useState(false);
  const [newConvertedData, setNewConvertedData] = useState([]);
  const [rentalOwnedData, setRentalOwnedData] = useState([]);

  // Salesperson dropdown
  const [salespersonList, setSalespersonList] = useState([]);
  const [selectedSalesperson, setSelectedSalesperson] = useState(null);
  const [salespersonData, setSalespersonData] = useState([]);
  const [isReviewApproved, setIsReviewApproved] = useState(false);
  const [isReviewMode, setIsReviewMode] = useState(false);
  const [attachmentFields, setAttachmentFields] = useState([]);
  const [existingAttachments, setExistingAttachments] = useState([]);
  const [royaltyCalculationTypeData, setRoyaltyCalculationTypeData] = useState(
    []
  );
  const baseUrl = process.env.REACT_APP_API_URL;
  const Url = process.env.REACT_APP_LIVE_DOMAIN_URL;
  const addAttachment = () => {
    setAttachmentFields([
      ...attachmentFields,
      {
        id: Date.now(),
        attachmentType: "",
        attachmentTitle: "",
        file: null,
      },
    ]);
  };

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [levelsData, setLevelsData] = useState([]);

  const fetchLevelsData = async () => {
    try {
      const levelsResponse = await get(
        `Dropdown/GetAllOrganizationLevelsByOrganizationId?organizationId=${organizationId}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setLevelsData(levelsResponse);
      return levelsResponse; // ✅ Return the data
    } catch (error) {
      console.error("Error fetching center data:", error);
      return []; // Return empty array on error
    }
  };

  useEffect(() => {
    fetchLevelsData();
  }, []);

  const removeAttachment = (index) => {
    const updated = [...attachmentFields];
    updated.splice(index, 1);
    setAttachmentFields(updated);
  };

  const updateAttachmentField = (index, field, value) => {
    const updated = [...attachmentFields];
    updated[index][field] = value;
    setAttachmentFields(updated);
  };

  const {
    register,
    control,
    handleSubmit,
    formState: { errors, isSubmitting },
    reset,
    watch,
    getValues,
    setValue,
    trigger,
  } = useForm({
    defaultValues: {
      franchiseId: 0,
      franchiseCode: "",
      ownerName: "",
      partners: [],
      paymentInstallments: [],
      royalties: [],
      salespeople: [],
    },
  });

  const navigate = useNavigate();

  const {
    fields: partnerFields,
    append: appendPartner,
    remove: removePartner,
  } = useFieldArray({ control, name: "partners" });
  const {
    fields: installmentFields,
    append: appendInstallment,
    remove: removeInstallment,
  } = useFieldArray({ control, name: "paymentInstallments" });
  const {
    fields: royaltyFields,
    append: appendRoyalty,
    remove: removeRoyalty,
  } = useFieldArray({ control, name: "royalties" });
  const {
    fields: salespersonFields,
    append: appendSalesperson,
    remove: removeSalesperson,
    move: moveSalesperson,
  } = useFieldArray({ control, name: "salespeople" });

  // Watch fields
  const watchTotalFee = watch("totalFranchiseFee");
  const watchDiscount = watch("discount");
  const watchNewConverted = watch("newConverted");
  const watchSalespeople = watch("salespeople");

  // Add this function in your component
  const fetchCampusCode = async (id) => {
    console.log("fid", id);
    try {
      const response = await get(
        // `Franchise/next-campus-code?regionId=${regionId}&cityId=${cityId}`,
        `Franchise/next-campus-code?franchiseId=${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response?.campusCode) {
        setValue("campusCode", response.campusCode);
      }
    } catch (error) {
      console.error("Error fetching campus code:", error);
    }
  };

  // Add useEffect to watch region and city changes
  // useEffect(() => {
  //   const regionId = watch("region")?.value;
  //   const cityId = watch("city")?.value;

  //   if (regionId && cityId) {
  //     fetchCampusCode(regionId, cityId);
  //   }
  // }, [watch("region"), watch("city")]);

  useEffect(() => {
    const total = parseFloat(watchTotalFee) || 0;
    const discount = parseFloat(watchDiscount) || 0;
    const netFee = total - discount;
    setValue("netFeeAfterDiscount", netFee >= 0 ? netFee : 0);
  }, [watchTotalFee, watchDiscount, setValue]);

  useEffect(() => {
    if (watchNewConverted?.label === "Converted") {
      setShowCollaboration(true);
    } else {
      setShowCollaboration(false);
      setValue("currentCollaboration", null);
    }
  }, [watchNewConverted, setValue]);

  const selectedGroups = useWatch({ control, name: "group", defaultValue: [] });
  // const selectedCountry = watch("countryId");
  // const selectedState = watch("stateId");
  // const selectedCity = watch("cityId");

  // Fetch countries
  // useEffect(() => {
  //   const fetchCountries = async () => {
  //     try {
  //       const response = await get("Dropdown/GetCountries", {
  //         headers: { Authorization: `Bearer ${token}` },
  //       });
  //       setCountries(response);
  //     } catch (error) {
  //       console.error("Error fetching countries:", error);
  //     }
  //   };
  //   fetchCountries();
  // }, [token]);

  // Rest of the existing useEffects and handlers
  useEffect(() => {
    const updatedAccountString = selectedGroups
      .map((group) => group?.code || "")
      .filter((code) => code)
      .join("-");
    setValue("accountString", updatedAccountString);
    trigger("accountString");
  }, [selectedGroups, setValue]);

  // useEffect(() => {
  //   if (selectedCountry && selectedCountry.value && !loading) {
  //     // Add !loading check
  //     const fetchStates = async () => {
  //       try {
  //         const response = await get(
  //           `Dropdown/GetStates?countryId=${selectedCountry.value}`,
  //           {
  //             headers: { Authorization: `Bearer ${token}` },
  //           }
  //         );
  //         setStates(response);
  //         // ✅ Only clear if not in edit mode
  //         if (mode !== "edit") {
  //           setCities([]);
  //           setValue("stateId", null);
  //           setValue("cityId", null);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching states:", error);
  //       }
  //     };
  //     fetchStates();
  //   }
  // }, [selectedCountry, setValue, token, loading, mode]);

  // useEffect(() => {
  //   if (selectedState && selectedState.value && !loading) {
  //     // Add !loading check
  //     const fetchCities = async () => {
  //       try {
  //         const response = await get(
  //           `Dropdown/GetCities?stateId=${selectedState.value}`,
  //           {
  //             headers: { Authorization: `Bearer ${token}` },
  //           }
  //         );
  //         setCities(response);
  //         // ✅ Only clear if not in edit mode
  //         if (mode !== "edit") {
  //           setValue("cityId", null);
  //         }
  //       } catch (error) {
  //         console.error("Error fetching cities:", error);
  //       }
  //     };
  //     fetchCities();
  //   }
  // }, [selectedState, setValue, token, loading, mode]);

  const calculateSalespersonTotals = () => {
    if (!watchSalespeople || watchSalespeople.length === 0) {
      return { totalFee: 0, totalRoyaltyAmt: 0, avgRoyaltyPct: 0 };
    }

    let totalFee = 0;
    let totalRoyaltyAmt = 0;
    let pctSum = 0;
    let pctCount = 0;

    watchSalespeople.forEach((sp) => {
      totalFee += parseFloat(sp.franchiseFeeContribution || 0);
      totalRoyaltyAmt += parseFloat(sp.monthlyRoyaltyAmount || 0);
      const pct = parseFloat(sp.monthlyRoyaltyPercentage || 0);
      if (pct > 0) {
        pctSum += pct;
        pctCount++;
      }
    });

    return {
      totalFee: totalFee.toFixed(2),
      totalRoyaltyAmt: totalRoyaltyAmt.toFixed(2),
      avgRoyaltyPct: pctCount > 0 ? (pctSum / pctCount).toFixed(2) : "0.00",
    };
  };

  const fetchNextCode = async () => {
    try {
      const res = await get("Franchise/next-code", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setNextFranchiseCode(res.franchiseCode);
    } catch (error) {
      console.error("Failed to fetch next franchise code:", error);
      toast.error("Failed to fetch next franchise code");
    }
  };

  const fetchCommonSettings = async (moduleName, setData) => {
    try {
      const response = await get(
        `CommonSettings/GetCommonSettingDetailByModuleName?moduleName=${moduleName}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setData(response?.commonSettingDetail || []);
    } catch (error) {
      console.error(`Error fetching ${moduleName}:`, error);
      toast.error(`Failed to fetch ${moduleName} data`);
    }
  };

  const loadSalespersonList = () => {
    const saved = localStorage.getItem("salespeople_list");
    const defaultList = [
      "Mr. Hasan",
      "Ms. Nimra",
      "Mr. Qaiser",
      "Mr. Ali",
      "Ms. Wajiha",
      "Mr. Irfan",
    ];
    const list = saved ? JSON.parse(saved) : defaultList;
    setSalespersonList(list.map((name) => ({ value: name, label: name })));
  };

  const loadFranchiseForEdit = async (id, levelsDataParam) => {
    try {
      setLoading(true);
      const response = await get(`Franchise/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("response", JSON.stringify(response));

      if (response) {
        // ✅ FIX 1: First load states and cities BEFORE reset
        // if (response.countryId) {
        //   try {
        //     const statesResponse = await get(
        //       `Dropdown/GetStates?countryId=${response.countryId}`,
        //       { headers: { Authorization: `Bearer ${token}` } }
        //     );
        //     setStates(statesResponse);

        //     if (response.stateId) {
        //       const citiesResponse = await get(
        //         `Dropdown/GetCities?stateId=${response.stateId}`,
        //         { headers: { Authorization: `Bearer ${token}` } }
        //       );
        //       setCities(citiesResponse);
        //     }
        //   } catch (error) {
        //     console.error("Error fetching location data:", error);
        //   }
        // }

        // ✅ FIX 2: Use the passed levelsDataParam instead of state
        const accountStringParts = (response.accountString || "").split("-");
        const groupValues = [];

        console.log("AccountString:", response.accountString);
        console.log("Levels Data:", levelsDataParam);

        for (let index = 0; index < accountStringParts.length; index++) {
          const code = accountStringParts[index];
          if (!code) continue;

          const levelGroup = levelsDataParam[index] || [];
          const foundLevel = levelGroup.find((item) => item.code === code);

          console.log(
            `Looking for code '${code}' in group ${index}:`,
            levelGroup
          );
          console.log(`Found:`, foundLevel);

          if (foundLevel) {
            groupValues[index] = {
              value: foundLevel.levelDetailId,
              label: foundLevel.name,
              code: foundLevel.code,
            };
          }
        }

        console.log("Final groupValues:", groupValues);

        reset({
          franchiseId: response.franchiseId,
          franchiseCode: response.franchiseCode,
          ownerName: response.ownerName,
          ownerCity: response.ownerCityId
            ? { value: response.ownerCityId, label: response.ownerCity }
            : null,
          ownerAddress: response.ownerAddress,
          ownerMobile: response.ownerMobile,
          ownerEmail: response.ownerEmail,
          ownerCnic: response.ownerCnic,

          region: response.regionId
            ? { value: response.regionId, label: response.regionValue }
            : null,
          city: response.cityId
            ? { value: response.cityId, label: response.cityValue }
            : null,

          campusCode: response.campusCode,
          campusName: response.campusName,
          campusAddress: response.campusAddress,
          area: response.area,
          rooms: response.rooms,
          studentStrength: response.studentStrength,
          currentCollaboration: response.currentCollaboration,
          currentSyllabus: response.currentSyllabus,

          newConverted: response.newConvertedId
            ? {
                value: response.newConvertedId,
                label: response.newConvertedValue,
              }
            : null,
          rentalOwned: response.rentalOwnedId
            ? {
                value: response.rentalOwnedId,
                label: response.rentalOwnedValue,
              }
            : null,
          schoolCategory: response.schoolCategoryId
            ? {
                value: response.schoolCategoryId,
                label: response.schoolCategoryValue,
              }
            : null,

          // ✅ LEVELS
          group: groupValues,
          accountString: response.accountString,

          admissionFee: response.admissionFee,
          securityFee: response.securityFee,
          annualCharges: response.annualCharges,
          registrationFee: response.registrationFee,
          prospectusFee: response.prospectusFee,
          monthlyFee: response.monthlyFee,
          otherCharges: response.otherCharges,
          phoneNumber: response.phoneNumber,
          landlineNumber: response.landLineNumber,

          // // ✅ COUNTRY
          // countryId:
          //   response.countryId && response.countryName
          //     ? { value: response.countryId, label: response.countryName }
          //     : null,

          organizationId: response.organizationId,

          // ✅ STATE
          // stateId:
          //   response.stateId && response.stateName
          //     ? { value: response.stateId, label: response.stateName }
          //     : null,

          // // ✅ CITY (CASCADE)
          // cityId:
          //   response.cityId && response.cascadeCityName
          //     ? { value: response.cityId, label: response.cascadeCityName }
          //     : null,

          totalFranchiseFee: response.totalFranchiseFee,
          discount: response.discount,
          netFeeAfterDiscount: response.netFeeAfterDiscount,
          paymentRemark: response.paymentRemark,
          agreementDate: response.agreementDate
            ? response.agreementDate.split("T")[0]
            : "",

          partners: (response.partners || []).map((p) => ({
            ...p,
            city: p.cityId ? { value: p.cityId, label: p.city } : null,
          })),

          royalties:
            (response.royalties || []).map((r) => ({
              ...r,
              calculationType: r.calculationTypeId
                ? {
                    value: r.calculationTypeId,
                    label: r.calculationType,
                  }
                : null,
              calculatedTotalAmount: r.calculatedTotalAmount,
            })) || [],

          paymentInstallments: (response.paymentInstallments || []).map(
            (inst) => ({
              ...inst,
              chequeDate: inst.chequeDate ? inst.chequeDate.split("T")[0] : "",
            })
          ),

          salespeople: response.salespeople || [],
        });

        setCurrentFranchiseId(response.franchiseId);
        setIsUnderReview(response.isUnderReview);
        setIsFinallyCompleted(response.isFinallyCompleted);
      }
    } catch (error) {
      console.error("Error loading franchise:", error);
      toast.error("Failed to load franchise data");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setIsEditMode(mode === "edit");

    fetchCommonSettings("region", setRegionData);
    fetchCommonSettings("city", setCityData);
    fetchCommonSettings("schoolCategory", setSchoolCategoryData);
    fetchCommonSettings("franchiseCampusType", setNewConvertedData);
    fetchCommonSettings("franchiseCampusOwnership", setRentalOwnedData);
    fetchCommonSettings("salesperson", setSalespersonData);
    fetchCommonSettings(
      "royaltyCalculationType",
      setRoyaltyCalculationTypeData
    );
    loadSalespersonList();

    // ✅ FIX: Load levels first, THEN pass it to loadFranchiseForEdit
    const loadData = async () => {
      if (mode === "edit" && franchiseIdFromUrl) {
        const fetchedLevels = await fetchLevelsData(); // Wait for levels
        await loadFranchiseForEdit(parseInt(franchiseIdFromUrl), fetchedLevels); // Pass levels
        loadFranchiseAttachments(parseInt(franchiseIdFromUrl));
        fetchCampusCode(parseInt(franchiseIdFromUrl));
      } else if (currentFranchiseId === 0) {
        await fetchLevelsData(); // Still load levels for new mode
        fetchNextCode();
        fetchCampusCode(currentFranchiseId);
      }
    };

    loadData();
  }, [mode, franchiseIdFromUrl]);

  useEffect(() => {
    if (mode === "new" && partnerFields.length === 0) {
      appendPartner({}); // Add one blank partner by default
    }
  }, [mode]);
  const saveCurrentStep = async (stepName) => {
    const stepKey = stepName.toLowerCase();
    setStepSavingStates((prev) => ({ ...prev, [stepKey]: true }));

    try {
      let response;
      const formData = getValues();
      formData.userid = user;

      switch (stepName) {
        case "franchise":
          response = await saveOwnerStep(formData);
          // UPDATE: Set the franchise ID after creating new franchise
          if (response.isSuccess && response.franchiseId) {
            fetchCampusCode(response.franchiseId);
            setCurrentFranchiseId(response.franchiseId);
            setValue("franchiseId", response.franchiseId);
            setValue("franchiseCode", response.franchiseCode);
          }
          break;
        case "partners":
          response = await savePartnersStep(formData);
          break;
        case "campus":
          response = await saveCampusStep(formData);
          break;
        case "payment":
          response = await savePaymentStep(formData);
          break;
        case "salesperson":
          response = await saveSalespersonStep(formData);
          break;
        case "attachments":
          response = await saveAttachmentsStep(formData);
          break;
        default:
          throw new Error("Unknown step");
      }

      if (response?.isSuccess) {
        toast.success(response.message);
        if (response.franchiseId && currentFranchiseId === 0) {
          setCurrentFranchiseId(response.franchiseId);
          setValue("franchiseId", response.franchiseId);
          setValue("franchiseCode", response.franchiseCode);
        }
        return true;
      } else {
        toast.error(response.message);
        return false;
      }
    } catch (error) {
      console.error(`Error saving ${stepName} step:`, error);
      toast.error(`Failed to save ${stepName} step`);
      return false;
    } finally {
      setStepSavingStates((prev) => ({ ...prev, [stepKey]: false }));
    }
  };

  const saveOwnerStep = async (formData) => {
    const stepData = {
      franchiseId: currentFranchiseId,
      ownerName: formData.ownerName,
      ownerCityId: formData.ownerCity?.value || null,
      ownerCity: formData.ownerCity?.label || null,
      ownerAddress: formData.ownerAddress,
      ownerMobile: formData.ownerMobile,
      ownerEmail: formData.ownerEmail,
      ownerCnic: formData.ownerCnic,
      userid: user,
    };
    console.log("data", JSON.stringify(stepData));
    const response = await post("Franchise/step/owner", stepData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    return response;
  };
  const savePartnersStep = async (formData) => {
    const stepData = {
      franchiseId: currentFranchiseId,
      partners: (formData.partners || []).map((p) => ({
        name: p.name || "",
        cityId: p.city?.value || null,
        city: p.city?.label || "",
        address: p.address || "",
        mobile: p.mobile || "",
        email: p.email || "",
        cnic: p.cnic || "",
      })),
      userid: user,
    };
    console.log("data", JSON.stringify(stepData));
    return await post("Franchise/step/partners", stepData, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
  };
  const saveCampusStep = async (formData) => {
    const selectedLevels = formData.group || [];
    const accountString = formData.accountString || "";

    // Final validation before API call
    if (selectedLevels.length === 0 || selectedLevels.some((g) => !g)) {
      toast.error("Please select all required levels.");
      return { isSuccess: false };
    }

    if (
      !accountString ||
      (accountString.includes("-") && accountString.trim().endsWith("-"))
    ) {
      toast.error("Account String is incomplete. Please select all levels.");
      return { isSuccess: false };
    }

    const stepData = {
      franchiseId: currentFranchiseId,
      // Old region/city (keep if backend still expects)
      regionId: formData.region?.value || null,
      cityId: formData.city?.value || null,

      // NEW: Proper cascading Country > State > City
      // countryId: formData.countryId?.value || null,
      organizationId: organizationId,
      // stateId: formData.stateId?.value || null,
      // cityId: formData.cityId?.value || null, // This is the correct one now

      phoneNumber: formData.phoneNumber || null,
      landlineNumber: formData.landlineNumber || null,

      campusCode: formData.campusCode || null,
      campusName: formData.campusName || null,
      campusAddress: formData.campusAddress || null,

      schoolCategoryId: formData.schoolCategory?.value || null,
      newConverted: formData.newConverted?.value || null,
      currentCollaboration: formData.currentCollaboration || null,
      rentalOwned: formData.rentalOwned?.value || null,

      area: formData.area || null,
      rooms: formData.rooms ? parseInt(formData.rooms) : null,
      studentStrength: formData.studentStrength
        ? parseInt(formData.studentStrength)
        : null,
      currentSyllabus: formData.currentSyllabus || null,

      admissionFee: formData.admissionFee
        ? parseInt(formData.admissionFee)
        : null,
      securityFee: formData.securityFee ? parseInt(formData.securityFee) : null,
      annualCharges: formData.annualCharges
        ? parseInt(formData.annualCharges)
        : null,
      registrationFee: formData.registrationFee
        ? parseInt(formData.registrationFee)
        : null,
      prospectusFee: formData.prospectusFee
        ? parseInt(formData.prospectusFee)
        : null,
      monthlyFee: formData.monthlyFee ? parseInt(formData.monthlyFee) : null,
      otherCharges: formData.otherCharges
        ? parseInt(formData.otherCharges)
        : null,

      // THIS IS THE KEY: Send accountString exactly like CenterForm
      accountString: accountString.trim(),

      userid: user,
    };
    console.log("Campus Data Being Sent:", JSON.stringify(stepData, null, 2));
    return await post("Franchise/step/campus", stepData, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };
  const savePaymentStep = async (formData) => {
    // Validate installment total
    if (!validateInstallmentTotal()) {
      toast.error("Total installment amount must equal Net Franchise Fee!");
      return {
        isSuccess: false,
        message: "Total installment amount must equal Net Franchise Fee!",
      };
    }

    const stepData = {
      franchiseId: currentFranchiseId,
      totalFranchiseFee: formData.totalFranchiseFee || null,
      discount: formData.discount || null,
      netFeeAfterDiscount: formData.netFeeAfterDiscount || null,
      paymentRemark: formData.paymentRemark || "",
      agreementDate: formData.agreementDate || null,
      paymentInstallments: (formData.paymentInstallments || []).map((inst) => ({
        installmentNo: inst.installmentNo || 0,
        amount: inst.amount || 0,
        chequeNo: inst.chequeNo || null,
        chequeDate: inst.chequeDate || null,
        bank: inst.bank || null,
        remark: inst.remark || "",
        isPaid: inst.isPaid || false, // NEW
        paidDate: inst.isPaid ? new Date().toISOString() : null, // NEW
      })),
      royalties: (formData.royalties || []).map((r) => ({
        year: r.year || null,
        amount: r.amount || null,
        percent: r.percent || null,
        calculationTypeId: r.calculationType?.value || null, // NEW
        calculationType: r.calculationType?.label || null, // NEW
        paymentDay: r.paymentDay || 10,
        remark: r.remark || null,
      })),
      userid: user,
    };
    console.log("payment", JSON.stringify(stepData));
    return await post("Franchise/step/payment", stepData, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  const saveSalespersonStep = async (formData) => {
    const totals = calculateSalespersonTotals();
    const stepData = {
      franchiseId: currentFranchiseId,
      salespeople: (formData.salespeople || []).map((sp, index) => ({
        salespersonId: sp.salespersonId || null, // NEW
        salespersonName: sp.salespersonName || "",
        franchiseFeeContribution: sp.franchiseFeeContribution || null,
        monthlyRoyaltyAmount: sp.monthlyRoyaltyAmount || null,
        monthlyRoyaltyPercentage: sp.monthlyRoyaltyPercentage || null,
        withholdingTaxPercent: sp.withholdingTaxPercent || null,
        termsAndConditions: sp.termsAndConditions || null,
        displayOrder: index + 1,
      })),
      summary: {
        totalFranchiseFee: parseFloat(totals.totalFee),
        totalRoyaltyAmount: parseFloat(totals.totalRoyaltyAmt),
        averageRoyaltyPercentage: parseFloat(totals.avgRoyaltyPct),
      },
      userid: user,
    };
    return await post("Franchise/step/salesperson", stepData, {
      headers: { Authorization: `Bearer ${token}` },
    });
  };

  const saveAttachmentsStep = async () => {
    const formData = new FormData();
    formData.append("franchiseId", currentFranchiseId.toString());
    formData.append("userid", user);

    // Append files and metadata
    attachmentFields.forEach((att, index) => {
      if (att.file) {
        formData.append(`files`, att.file);
        formData.append(`attachmentTypes`, att.attachmentType);
        formData.append(`attachmentTitles`, att.attachmentTitle);
      }
    });

    try {
      const response = await post("Franchise/step/attachments", formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      if (response.isSuccess) {
        toast.success(response.message);
        setAttachmentFields([]); // Clear form
        loadFranchiseAttachments(currentFranchiseId); // Reload

        if (response.message.includes("completed")) {
          setIsFinallyCompleted(true);
        }
      } else {
        toast.error(response.message);
      }

      return response;
    } catch (error) {
      console.error("Error saving attachments:", error);
      toast.error("Failed to save attachments");
      return { isSuccess: false };
    }
  };

  const loadFranchiseAttachments = async (franchiseId) => {
    try {
      const response = await get(`Franchise/${franchiseId}/attachments`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setExistingAttachments(response || []);
    } catch (error) {
      console.error("Error loading attachments:", error);
    }
  };

  const deleteAttachment = async (attachmentId) => {
    if (!window.confirm("Are you sure you want to delete this attachment?"))
      return;

    try {
      const response = await post(
        `Franchise/attachment/${attachmentId}/delete`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        toast.success("Attachment deleted successfully");
        loadFranchiseAttachments(currentFranchiseId);
      } else {
        toast.error("Failed to delete attachment");
      }
    } catch (error) {
      console.error("Error deleting attachment:", error);
      toast.error("Failed to delete attachment");
    }
  };
  const handleStartReview = () => {
    setIsReviewMode(true);
    setActiveTab("franchise");
    toast.info("Please review all information starting from the first tab");
  };
  const handleDownloadMOU = async () => {
    try {
      //  const baseUrl = process.env.REACT_APP_API_URL;

      console.log("url", baseUrl);
      const downloadUrl = `${baseUrl}Franchise/${currentFranchiseId}/download-mou`;

      window.open(downloadUrl, "_blank");
      toast.success("MOU download started");
    } catch (error) {
      console.error("MOU download failed:", error);
      toast.error("Failed to download MOU");
    }
  };

  const handleDownloadCertificate = async () => {
    try {
      console.log("url", baseUrl);
      const downloadUrl = `${baseUrl}Franchise/download-certificate/${currentFranchiseId}`;

      window.open(downloadUrl, "_blank");

      toast.success("Certificate downloaded!");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Download failed");
    }
  };

  const handleDownloadStandee = async () => {
    try {
      console.log("url", baseUrl);
      const downloadUrl = `${baseUrl}Franchise/download-standee/${currentFranchiseId}`;

      window.open(downloadUrl, "_blank");

      toast.success("Standee downloaded!");
    } catch (error) {
      console.error("Error:", error);
      toast.error("Download failed");
    }
  };

  const handleFinalSubmit = async () => {
    const confirmed = window.confirm(
      "Are you sure you want to make final submission? This cannot be undone."
    );
    if (!confirmed) return;

    try {
      const response = await post(
        `Franchise/${currentFranchiseId}/final-submit`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message);
        setIsFinallyCompleted(true);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error in final submit:", error);
      toast.error("Failed to complete franchise");
    }
  };

  const addNewSalesperson = () => {
    const name = prompt("Enter new salesperson name:");
    if (!name) return;

    const list = JSON.parse(localStorage.getItem("salespeople_list") || "[]");
    if (!list.includes(name)) {
      list.push(name);
      localStorage.setItem("salespeople_list", JSON.stringify(list));
      loadSalespersonList();
      setSelectedSalesperson({ value: name, label: name });
    }
  };

  const resetForm = () => {
    reset({
      franchiseId: 0,
      franchiseCode: "",
      ownerAddress: "",
      ownerCity: "",
      ownerCnic: "",
      ownerName: "",
      ownerEmail: "",
      ownerMobile: "",
      partners: [],
      paymentInstallments: [],
      royalties: [],
      salespeople: [],
    });
    setCurrentFranchiseId(0);
    setActiveTab("franchise");
    setIsUnderReview(false);
    setIsFinallyCompleted(false);
    navigate("/franchise?mode=new");
  };

  const renderSelect = (
    name,
    label,
    options,
    moduleName,
    rules = { required: "This field is required." }
  ) => (
    <div className="col-md-4">
      <label className="form-label">
        {label}
        {rules.required && <span className="text-danger fs-9">*</span>}
      </label>
      <div className="d-flex gap-2">
        <div className="w-100">
          <Controller
            name={name}
            control={control}
            rules={rules}
            render={({ field }) => (
              <Select
                {...field}
                options={options.map((item) => ({
                  value: item.id,
                  label: item.value,
                }))}
                isClearable
                className="react-select-style"
                classNamePrefix="react-select-style-pref"
              />
            )}
          />
        </div>
        <div>
          <button
            type="button"
            className="btn btn-outline-primary"
            style={{ padding: "5.5px 10px" }}
            onClick={() => {
              setModalModuleName(moduleName);
              setModalVisible(true);
            }}
          >
            <i className="fas fa-plus"></i>
          </button>
        </div>
      </div>
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );

  const renderStepActions = (stepName, backTab, nextTab) => (
    <div className="wizard-actions mt-4 d-flex justify-content-between">
      <div>
        {backTab && (
          <button
            type="button"
            className="btn btn-outline-secondary me-2"
            onClick={() => setActiveTab(backTab)}
          >
            Back
          </button>
        )}
      </div>
      <div>
        {nextTab ? (
          <button
            type="button"
            className="btn btn-primary"
            onClick={async () => {
              const isValid = await trigger();
              if (!isValid) return;

              const success = await saveCurrentStep(stepName);
              if (success) {
                setActiveTab(nextTab);
                window.scrollTo(0, 0);
              }
            }}
            disabled={stepSavingStates[stepName.toLowerCase()]}
          >
            {stepSavingStates[stepName.toLowerCase()]
              ? "Saving..."
              : `Save & Next`}
          </button>
        ) : (
          <button
            type="button"
            className="btn btn-success me-2"
            onClick={async () => {
            const isValid = await trigger();
            if (!isValid) return;
            saveCurrentStep(stepName);
          }}
            disabled={stepSavingStates[stepName.toLowerCase()]}
          >
            {stepSavingStates[stepName.toLowerCase()]
              ? "Saving..."
              : `Save ${stepName}`}
          </button>
        )}
      </div>
    </div>
  );

  const totals = calculateSalespersonTotals();

  const formatCNIC = (value) => {
    if (!value) return "";
    const numbers = value.replace(/\D/g, "");
    if (numbers.length <= 5) return numbers;
    if (numbers.length <= 12)
      return `${numbers.slice(0, 5)}-${numbers.slice(5)}`;
    return `${numbers.slice(0, 5)}-${numbers.slice(5, 12)}-${numbers.slice(
      12,
      13
    )}`;
  };

  const countryPhoneLengths = {
    PK: 10,
    SA: 9,
    AE: 9,
    US: 10,
  };

  // Phone Input Component
  const renderPhoneInput = (name, label, required = true) => (
    <div className="col-md-4">
      <label className="form-label">
        {label}
        {required && <span className="text-danger fs-9">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? "This field is required." : false,
          validate: (value) => {
            if (!value && !required) return true;
            if (!value) return "This field is required.";

            const parsed = parsePhoneNumberFromString(value);
            if (!parsed) return "Invalid phone number format";

            const countryCode = parsed.country;
            const nationalNumber = parsed.nationalNumber;
            const maxLength = countryPhoneLengths[countryCode];

            if (maxLength && nationalNumber.length !== maxLength) {
              return `Phone number must be exactly ${maxLength} digits for ${countryCode}`;
            }

            const totalDigits = value.replace(/[^0-9]/g, "").length;
            if (totalDigits > 12) {
              return "Phone number cannot exceed 12 digits";
            }

            return true;
          },
        }}
        render={({ field: { onChange, value } }) => (
          <PhoneInput
            value={value}
            onChange={(newValue) => {
              const digitCount = (newValue || "").replace(/[^0-9]/g, "").length;
              if (!newValue || digitCount <= 12) {
                onChange(newValue);
              }
            }}
            defaultCountry="PK"
            international
            countryCallingCodeEditable={false}
            className="custom-phone-input"
            placeholder="Enter phone number"
            inputProps={{ maxLength: 16 }}
            onKeyDown={(e) => {
              const inputValue = e.target.value || "";
              const digitCount = inputValue.replace(/[^0-9]/g, "").length;
              if (
                digitCount >= 12 &&
                e.key !== "Backspace" &&
                e.key !== "Delete" &&
                e.key !== "ArrowLeft" &&
                e.key !== "ArrowRight" &&
                e.key !== "Tab"
              ) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              const pastedData = e.clipboardData.getData("text");
              const newDigitCount = (value + pastedData).replace(
                /[^0-9]/g,
                ""
              ).length;
              if (newDigitCount > 12) {
                e.preventDefault();
              }
            }}
          />
        )}
      />
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );

  // Email Input Component
  const renderEmailInput = (name, label, required = true) => (
    <div className="col-md-4">
      <label className="form-label">
        {label}
        {required && <span className="text-danger fs-9">*</span>}
      </label>
      <input
        type="email"
        {...register(name, {
          required: required ? "This field is required." : false,
          pattern: {
            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
            message: "Invalid email address",
          },
          validate: {
            noSpaces: (value) =>
              !value || !/\s/.test(value) || "Email cannot contain spaces",
            validDomain: (value) => {
              if (!value) return true;
              const domain = value.split("@")[1];
              return (domain && domain.includes(".")) || "Invalid email domain";
            },
          },
        })}
        className="form-control"
        placeholder="example@email.com"
      />
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );

  // CNIC Input Component
  const renderCNICInput = (name, label, required = true) => (
    <div className="col-md-4">
      <label className="form-label">
        {label}
        {required && <span className="text-danger fs-9">*</span>}
      </label>
      <Controller
        name={name}
        control={control}
        rules={{
          required: required ? "This field is required." : false,
          validate: {
            length: (value) => {
              if (!value && !required) return true;
              const numbers = (value || "").replace(/\D/g, "");
              return numbers.length === 13 || "CNIC must be exactly 13 digits";
            },
            numbersOnly: (value) => {
              if (!value && !required) return true;
              const numbers = (value || "").replace(/\D/g, "");
              return /^\d+$/.test(numbers) || "CNIC must contain only numbers";
            },
          },
        }}
        render={({ field: { onChange, value, onBlur } }) => (
          <input
            type="text"
            value={formatCNIC(value || "")}
            onChange={(e) => {
              const input = e.target.value;
              const numbers = input.replace(/\D/g, "");
              if (numbers.length <= 13) {
                onChange(numbers);
              }
            }}
            onBlur={onBlur}
            className="form-control"
            placeholder="12345-1234567-1"
            maxLength={15}
          />
        )}
      />
      {errors[name] && (
        <small className="text-danger">{errors[name].message}</small>
      )}
    </div>
  );
  const renderSalespersonDropdown = () => (
    <div className="d-flex gap-2 mb-3 align-items-end">
      <div style={{ flex: 1 }}>
        <label className="form-label">Select Salesperson</label>
        <Controller
          name="selectedSalesperson"
          control={control}
          render={({ field }) => (
            <Select
              {...field}
              value={selectedSalesperson}
              onChange={setSelectedSalesperson}
              options={salespersonData.map((item) => ({
                value: item.id,
                label: item.value,
              }))}
              isClearable
              placeholder="Select Salesperson..."
            />
          )}
        />
      </div>
      <div>
        <button
          type="button"
          className="btn btn-outline-primary"
          style={{ padding: "8px 16px" }}
          onClick={() => {
            setModalModuleName("salesperson");
            setModalVisible(true);
          }}
        >
          <i className="fas fa-plus"></i>
        </button>
      </div>
      <button
        type="button"
        className="btn btn-primary"
        onClick={addSalespersonToList}
      >
        + Add to List
      </button>
    </div>
  );

  const addSalespersonToList = () => {
    if (!selectedSalesperson) {
      toast.error("Please select a salesperson");
      return;
    }

    const exists = salespersonFields.some(
      (sp) => sp.salespersonId === selectedSalesperson.value
    );
    if (exists) {
      toast.error("This salesperson is already added");
      return;
    }

    appendSalesperson({
      salespersonId: selectedSalesperson.value,
      salespersonName: selectedSalesperson.label,
      franchiseFeeContribution: "",
      monthlyRoyaltyAmount: "",
      monthlyRoyaltyPercentage: "",
      withholdingTaxPercent: "",
      termsAndConditions: "",
    });
    setSelectedSalesperson(null);
  };

  const validateInstallmentTotal = () => {
    const netFee = parseFloat(watch("netFeeAfterDiscount")) || 0;
    const installments = watch("paymentInstallments") || [];

    const totalInstallments = installments.reduce((sum, inst) => {
      return sum + (parseFloat(inst.amount) || 0);
    }, 0);

    return Math.abs(totalInstallments - netFee) < 0.01; // Allow small floating point difference
  };
  const handleReviewAndApprove = async () => {
    const confirmed = window.confirm(
      "Have you reviewed all information? Click OK to approve and enable MOU download."
    );
    if (!confirmed) return;

    try {
      const response = await post(
        `Franchise/${currentFranchiseId}/review-approve`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.isSuccess) {
        toast.success(response.message);
        setIsReviewApproved(true);
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error approving review:", error);
      toast.error("Failed to approve review");
    }
  };
  return (
    <>
      <div className="row g-3">
        <div className="col-md-12">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Franchise Registration Form</h4>
            <div className="d-flex gap-2">
              <button
                type="button"
                className="btn btn-outline-secondary btn-sm"
                onClick={resetForm}
              >
                <i className="fas fa-plus me-1"></i> New Franchise
              </button>
              {currentFranchiseId > 0 && (
                <span className="badge bg-info fs-7">
                  {watch("franchiseCode") ||
                    `F-${currentFranchiseId.toString().padStart(5, "0")}`}
                </span>
              )}

              {/* Download MOU - Only visible after Review & Approve */}
              {isReviewApproved && !isFinallyCompleted && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleDownloadMOU}
                  >
                    <i className="fas fa-download me-1"></i> Download MOU
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleDownloadStandee}
                  >
                    <i className="fas fa-file-pdf me-1"></i> Download Standee
                  </button>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={handleDownloadCertificate}
                  >
                    <i className="fas fa-certificate me-1"></i> Download
                    Certificate
                  </button>
                </>
              )}

              {isFinallyCompleted && (
                <>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleDownloadMOU}
                  >
                    <i className="fas fa-download me-1"></i> Download MOU
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary btn-sm"
                    onClick={handleDownloadStandee}
                  >
                    <i className="fas fa-file-pdf me-1"></i> Download Standee
                  </button>
                  <button
                    type="button"
                    className="btn btn-success btn-sm"
                    onClick={handleDownloadCertificate}
                  >
                    <i className="fas fa-certificate me-1"></i> Download
                    Certificate
                  </button>
                  <span className="badge bg-success fs-7">
                    <i className="fas fa-check-circle me-1"></i> Completed
                  </span>
                </>
              )}
            </div>
          </div>
          <form noValidate>
            <div className="card">
              <div className="card-body">
                <ul className="nav nav-pills mb-3">
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "franchise" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("franchise")}
                    >
                      Franchise
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "partners" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("partners")}
                    >
                      Partners
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "campus" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("campus")}
                    >
                      Campus
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "payment" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("payment")}
                    >
                      Payment & Royalty
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "salesperson" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("salesperson")}
                    >
                      Salesperson
                    </button>
                  </li>
                  <li className="nav-item">
                    <button
                      className={`nav-link ${
                        activeTab === "attachments" ? "active" : ""
                      }`}
                      type="button"
                      onClick={() => setActiveTab("attachments")}
                    >
                      Attachments
                    </button>
                  </li>
                </ul>

                {activeTab === "franchise" && (
                  <div>
                    <h5 className="mb-3 fs-9 border-bottom pb-2">
                      1. Owner Information
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-4">
                        <label className="form-label">Franchise Code</label>
                        <input
                          value={watch("franchiseCode") || nextFranchiseCode}
                          className="form-control"
                          readOnly
                          style={{ backgroundColor: "#e9ecef" }}
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Full Name<span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          {...register("ownerName", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                        />
                        {errors.ownerName && (
                          <small className="text-danger">
                            {errors.ownerName.message}
                          </small>
                        )}
                      </div>
                      {renderSelect("ownerCity", "City", cityData, "city", {
                        required: "This field is required.",
                      })}{" "}
                      {/* CHANGED */}
                      {renderPhoneInput("ownerMobile", "Mobile", true)}
                      {renderEmailInput("ownerEmail", "Email", true)}
                      {renderCNICInput("ownerCnic", "CNIC", true)}
                      <div className="col-12">
                        <label className="form-label">
                          Address<span className="text-danger fs-9">*</span>
                        </label>
                        <textarea
                          {...register("ownerAddress", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                          rows="2"
                        ></textarea>
                        {errors.ownerAddress && (
                          <small className="text-danger">
                            {errors.ownerAddress.message}
                          </small>
                        )}
                      </div>
                    </div>
                    {renderStepActions("franchise", null, "partners")}
                  </div>
                )}

                {activeTab === "partners" && (
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0 fs-9 border-bottom pb-2">
                        2. Partners Information
                      </h5>
                      <button
                        type="button"
                        onClick={() => appendPartner({})}
                        className="btn btn-sm btn-primary"
                      >
                        + Add Partner
                      </button>
                    </div>
                    {partnerFields.map((item, index) => (
                      <div
                        className="border rounded p-3 mb-3 position-relative"
                        key={item.id}
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute top-0 end-0 m-2"
                          onClick={() => removePartner(index)}
                        ></button>
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label">Full Name</label>
                            <input
                              {...register(`partners.${index}.name`)}
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">City</label>
                            <Controller
                              name={`partners.${index}.city`}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={cityData.map((item) => ({
                                    value: item.id,
                                    label: item.value,
                                  }))}
                                  isClearable
                                  className="react-select-style"
                                  classNamePrefix="react-select-style-pref"
                                />
                              )}
                            />
                          </div>
                          {renderPhoneInput(
                            `partners.${index}.mobile`,
                            "Mobile",
                            false
                          )}
                          {renderEmailInput(
                            `partners.${index}.email`,
                            "Email",
                            false
                          )}
                          {renderCNICInput(
                            `partners.${index}.cnic`,
                            "CNIC",
                            false
                          )}

                          <div className="col-12">
                            <label className="form-label">Address</label>
                            <TextField
                              {...register(`partners.${index}.address`)}
                              className="form-control"
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                    {renderStepActions("partners", "franchise", "campus")}
                  </div>
                )}

                {activeTab === "campus" && (
                  <div>
                    <h5 className="mb-3 fs-9 border-bottom pb-2">
                      3. Campus Information
                    </h5>
                    <div className="row g-3">
                      {/* {renderSelect("region", "Region", regionData, "region", {
                        required: "Region is required",
                      })}
                      {renderSelect("city", "City", cityData, "city", {
                        required: "City is required",
                      })} */}

                      {/* LEVELS SELECTION - Same as CenterForm */}
                      {levelsData.length ? (
                        <>
                          <div className="col-12">
                            <h5 className="mb-2">
                              Levels<span className="text-danger fs-9">*</span>
                            </h5>
                            <div className="row g-2">
                              {levelsData.map((group, groupIndex) => (
                                <div className="col-2" key={groupIndex}>
                                  <Controller
                                    name={`group[${groupIndex}]`}
                                    control={control}
                                    rules={{
                                      required: "This field is required.",
                                    }}
                                    render={({ field }) => (
                                      <Select
                                        {...field}
                                        options={group.map((element) => ({
                                          value: element.levelDetailId,
                                          label: element.name,
                                          code: element.code,
                                        }))}
                                        onChange={(
                                          selectedOption,
                                          actionMeta
                                        ) => {
                                          if (actionMeta.action === "clear") {
                                            setValue(
                                              `group[${groupIndex}]`,
                                              null
                                            );
                                          } else {
                                            setValue(
                                              `group[${groupIndex}]`,
                                              selectedOption || {
                                                value: 0,
                                                label: "",
                                                code: "",
                                              }
                                            );
                                          }
                                          trigger(`group[${groupIndex}]`);
                                        }}
                                        className="react-select-style"
                                        classNamePrefix="react-select-style-pref"
                                        isClearable
                                      />
                                    )}
                                  />
                                  {errors.group?.[groupIndex] && (
                                    <small className="text-danger">
                                      {errors.group[groupIndex].message}
                                    </small>
                                  )}
                                </div>
                              ))}
                              <div className="col-md-12 mt-3 d-none">
                                <label className="form-label">
                                  Account String{" "}
                                  <span className="text-danger fs-9">*</span>
                                </label>
                                <input
                                  {...register("accountString", {
                                    required:
                                      "This field is required.",
                                  })}
                                  type="text"
                                  className="form-control"
                                  readOnly
                                  style={{ backgroundColor: "#e9ecef" }}
                                  placeholder="Auto-generated"
                                />
                                {errors.accountString && (
                                  <small className="text-danger">
                                    {errors.accountString.message}
                                  </small>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12">
                            <hr className="mt-1 mb-0" />
                          </div>
                        </>
                      ) : (
                        <small className="text-danger">
                          Please create levels first.
                        </small>
                      )}

                      {/* <div className="col-md-3">
                        <label className="form-label">
                          Country<span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="countryId"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={countries.map((country) => ({
                                value: country.id,
                                label: country.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("countryId", null);
                                } else {
                                  setValue(
                                    "countryId",
                                    selectedOption || {
                                      value: 0,
                                      label: "",
                                    }
                                  );
                                }
                                trigger("countryId");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                            />
                          )}
                        />
                        {errors.countryId && (
                          <small className="text-danger">
                            {errors.countryId.message}
                          </small>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">
                          State<span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="stateId"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={states.map((state) => ({
                                value: state.id,
                                label: state.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("stateId", null);
                                } else {
                                  setValue(
                                    "stateId",
                                    selectedOption || {
                                      value: 0,
                                      label: "",
                                    }
                                  );
                                }
                                trigger("stateId");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                            />
                          )}
                        />
                        {errors.stateId && (
                          <small className="text-danger">
                            {errors.stateId.message}
                          </small>
                        )}
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">
                          City<span className="text-danger fs-9">*</span>
                        </label>
                        <Controller
                          name="cityId"
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={cities.map((city) => ({
                                value: city.id,
                                label: city.name,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue("cityId", null);
                                } else {
                                  setValue(
                                    "cityId",
                                    selectedOption || {
                                      value: 0,
                                      label: "",
                                    }
                                  );
                                }
                                trigger("cityId");
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                            />
                          )}
                        />
                        {errors.cityId && (
                          <small className="text-danger">
                            {errors.cityId.message}
                          </small>
                        )}
                      </div> */}

                      {/* Phone Number (Required) */}
                      {renderPhoneInput(
                        "phoneNumber",
                        "Phone Number",
                        true
                      )}

                      {/* Landline Number (Optional) */}
                      <div className="col-md-4">
                        <label className="form-label">Landline Number</label>
                        <input
                          {...register("landlineNumber", {
                            validate: (val) => {
                              if (!val || val.trim() === "") return true; // optional
                              const digitsOnly = /^\d+$/;
                              if (!digitsOnly.test(val))
                                return "Landline must contain digits only";
                              if (val.length < 7)
                                return `Landline must be at least 7 digits`;
                              if (val.length > 11)
                                return `Landline must be at most 11 digits`;
                              return true;
                            },
                          })}
                          type="tel" // ← Changed from "text" (better for phone numbers)
                          inputMode="numeric" // ← Mobile keyboards show numbers only
                          className="form-control"
                          placeholder="e.g. 04212345678"
                        />
                        {errors.landlineNumber && (
                          <small className="text-danger">
                            {errors.landlineNumber.message}
                          </small>
                        )}
                      </div>

                      <div className="col-md-4">
                        <label className="form-label">Campus Code</label>
                        <input
                          {...register("campusCode")}
                          className="form-control"
                          readOnly
                          style={{ backgroundColor: "#e9ecef" }}
                          placeholder="Auto-generated"
                        />
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Campus Name<span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          {...register("campusName", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                        />
                        {errors.campusName && (
                          <small className="text-danger">
                            {errors.campusName.message}
                          </small>
                        )}
                      </div>
                      {renderSelect(
                        "schoolCategory",
                        "School Category",
                        schoolCategoryData,
                        "schoolCategory",
                        { required: "This field is required." }
                      )}
                      <div className="col-12">
                        <label className="form-label">
                          Address<span className="text-danger fs-9">*</span>
                        </label>
                        <textarea
                          {...register("campusAddress", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                          rows="2"
                        ></textarea>
                        {errors.campusAddress && (
                          <small className="text-danger">
                            {errors.campusAddress.message}
                          </small>
                        )}
                      </div>
                      {renderSelect(
                        "newConverted",
                        "New / Converted",
                        newConvertedData,
                        "franchiseCampusType",
                        { required: "This field is required." }
                      )}
                      {showCollaboration && (
                        <div className="col-md-4">
                          <label className="form-label">
                            Current Collaboration
                          </label>
                          <input
                            type="text"
                            {...register("currentCollaboration")}
                            className="form-control"
                            placeholder="Enter current collaboration"
                          />
                        </div>
                      )}
                      {renderSelect(
                        "rentalOwned",
                        "Rental / Owned",
                        rentalOwnedData,
                        "franchiseCampusOwnership",
                        { required: "This field is required." }
                      )}
                      <div className="col-md-4">
                        <label className="form-label">
                          Area<span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          type="text"
                          {...register("area", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                          placeholder="e.g., 5000 sq ft, Kanal, Marla"
                        />
                        {errors.area && (
                          <small className="text-danger">
                            {errors.area.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Rooms<span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          type="number"
                          {...register("rooms", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                        />
                        {errors.rooms && (
                          <small className="text-danger">
                            {errors.rooms.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">
                          Student Strength
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          type="number"
                          {...register("studentStrength", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                        />
                        {errors.studentStrength && (
                          <small className="text-danger">
                            {errors.studentStrength.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-4">
                        <label className="form-label">Current Syllabus</label>
                        <input
                          type="text"
                          {...register("currentSyllabus")}
                          className="form-control"
                          placeholder="Enter current syllabus"
                        />
                      </div>
                    </div>

                    {/* NEW: Student Fee Information Section */}
                    <h5 className="mb-3 mt-4 fs-9 border-bottom pb-2">
                      Student Fee Information
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">Admission Fee</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("admissionFee")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Security Fee</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("securityFee")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Annual Charges</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("annualCharges")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Registration Fee</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("registrationFee")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Prospectus Fee</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("prospectusFee")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Monthly Fee</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("monthlyFee")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>

                      <div className="col-md-3">
                        <label className="form-label">Other Charges</label>
                        <div className="input-group">
                          <span className="input-group-text">Rs.</span>
                          <input
                            type="number"
                            {...register("otherCharges")}
                            className="form-control"
                            placeholder="0"
                            step="1"
                          />
                        </div>
                      </div>
                    </div>
                    {renderStepActions("campus", "partners", "payment")}
                  </div>
                )}

                {activeTab === "payment" && (
                  <div>
                    <h5 className="mb-3 fs-9 border-bottom pb-2">
                      4. Franchise Fee & Payment
                    </h5>
                    <div className="row g-3">
                      <div className="col-md-3">
                        <label className="form-label">
                          Franchise Fee
                          <span className="text-danger fs-9">*</span>
                        </label>
                        <input
                          type="number"
                          {...register("totalFranchiseFee", {
                            required: "This field is required.",
                          })}
                          className="form-control"
                          step="0.01"
                        />
                        {errors.totalFranchiseFee && (
                          <small className="text-danger">
                            {errors.totalFranchiseFee.message}
                          </small>
                        )}
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Discount Amount</label>
                        <input
                          type="number"
                          {...register("discount")}
                          className="form-control"
                          step="0.01"
                        />
                      </div>
                      <div className="col-md-3">
                        <label className="form-label">Net Franchise Fee</label>
                        <input
                          type="number"
                          {...register("netFeeAfterDiscount")}
                          className="form-control"
                          readOnly
                          style={{ backgroundColor: "#e9ecef" }}
                        />
                      </div>
                      {/* <div className="col-md-3">
                                                <label className="form-label">Agreement Date</label>
                                                <input type="date" {...register("agreementDate")} className="form-control" />
                                            </div> */}
                      <div className="col-md-3">
                        <label className="form-label">Remark</label>
                        <textarea
                          {...register("paymentRemark")}
                          className="form-control"
                        ></textarea>
                      </div>
                    </div>

                    <hr className="my-4" />
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0 fs-9">
                        Franchise Fee Payment Detail
                      </h5>
                      <button
                        type="button"
                        onClick={() =>
                          appendInstallment({
                            installmentNo: installmentFields.length + 1,
                          })
                        }
                        className="btn btn-sm btn-primary"
                      >
                        + Add Payment
                      </button>
                    </div>
                    {installmentFields.map((item, index) => (
                      <div
                        className="border rounded p-3 mb-3 position-relative"
                        key={item.id}
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute top-0 end-0 m-2"
                          onClick={() => removeInstallment(index)}
                        ></button>
                        <div className="row g-3">
                          <div className="col-md-2">
                            <label className="form-label">
                              Installment No
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="number"
                              {...register(
                                `paymentInstallments.${index}.installmentNo`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                            />
                            {errors.paymentInstallments?.[index]?.installmentNo && (
                              <small className="text-danger">
                                {
                                  errors.paymentInstallments[index]
                                    .installmentNo.message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Amount<span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="number"
                              {...register(
                                `paymentInstallments.${index}.amount`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                              step="0.01"
                            />
                            {errors.paymentInstallments?.[index]?.amount && (
                              <small className="text-danger">
                                {
                                  errors.paymentInstallments[index].amount
                                    .message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Reference No
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="text"
                              {...register(
                                `paymentInstallments.${index}.chequeNo`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                            />
                            {errors.paymentInstallments?.[index]?.chequeNo && (
                              <small className="text-danger">
                                {
                                  errors.paymentInstallments[index].chequeNo
                                    .message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Paid Date
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="date"
                              {...register(
                                `paymentInstallments.${index}.chequeDate`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                            />
                            {errors.paymentInstallments?.[index]?.chequeDate && (
                              <small className="text-danger">
                                {
                                  errors.paymentInstallments[index].chequeDate
                                    .message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Bank<span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="text"
                              {...register(
                                `paymentInstallments.${index}.bank`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                            />
                            {errors.paymentInstallments?.[index]?.bank && (
                              <small className="text-danger">
                                {
                                  errors.paymentInstallments[index].bank
                                    .message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Remark</label>
                            <input
                              type="text"
                              {...register(
                                `paymentInstallments.${index}.remark`
                              )}
                              className="form-control"
                            />
                          </div>
                          <div className="col-md-12 mt-2">
                            <div className="form-check">
                              <input
                                type="checkbox"
                                {...register(
                                  `paymentInstallments.${index}.isPaid`
                                )}
                                className="form-check-input"
                                id={`isPaid-${index}`}
                              />
                              <label
                                className="form-check-label"
                                htmlFor={`isPaid-${index}`}
                              >
                                Mark as Paid
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}

                    <hr className="my-4" />
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <h5 className="mb-0 fs-9">Annual Royalty</h5>
                      <button
                        type="button"
                        onClick={() => appendRoyalty({ paymentDay: 10 })}
                        className="btn btn-sm btn-primary"
                      >
                        + Add Royalty
                      </button>
                    </div>
                    {royaltyFields.map((item, index) => (
                      <div
                        className="border rounded p-3 mb-3 position-relative"
                        key={item.id}
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute top-0 end-0 m-2"
                          onClick={() => removeRoyalty(index)}
                        ></button>
                        <div className="row g-3">
                          <div className="col-md-2">
                            <label className="form-label">
                              Year<span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="number"
                              {...register(`royalties.${index}.year`, {
                                required: "This field is required.",
                              })}
                              className="form-control"
                              placeholder="2025"
                            />
                            {errors.royalties?.[index]?.year && (
                              <small className="text-danger">
                                {errors.royalties[index].year.message}
                              </small>
                            )}
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Fixed Amount</label>
                            <input
                              type="number"
                              {...register(`royalties.${index}.amount`)}
                              className="form-control"
                              step="0.01"
                              placeholder="Enter amount"
                              disabled={!!watch(`royalties.${index}.percent`)} // Disable if percent has value
                              onChange={(e) => {
                                if (e.target.value)
                                  setValue(`royalties.${index}.percent`, "");
                              }}
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">Percentage</label>
                            <div className="input-group">
                              <input
                                type="number"
                                {...register(`royalties.${index}.percent`)}
                                className="form-control"
                                step="0.01"
                                placeholder="Enter percentage"
                                disabled={!!watch(`royalties.${index}.amount`)} // Disable if amount has value
                                onChange={(e) => {
                                  if (e.target.value)
                                    setValue(`royalties.${index}.amount`, "");
                                }}
                              />
                              <span className="input-group-text">%</span>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Calculation Type
                            </label>
                            <Controller
                              name={`royalties.${index}.calculationType`}
                              control={control}
                              render={({ field }) => (
                                <Select
                                  {...field}
                                  options={royaltyCalculationTypeData.map(
                                    (item) => ({
                                      value: item.id,
                                      label: item.value,
                                    })
                                  )}
                                  isClearable
                                  placeholder="Select..."
                                  className="react-select-style"
                                  classNamePrefix="react-select-style-pref"
                                />
                              )}
                            />
                          </div>
                          <div className="col-md-2">
                            <label className="form-label">
                              Payment Day (1-28)
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="number"
                              {...register(`royalties.${index}.paymentDay`, {
                                required: "This field is required.",
                                min: { value: 1, message: "Minimum day is 1" },
                                max: {
                                  value: 28,
                                  message: "Maximum day is 28",
                                },
                              })}
                              className="form-control"
                              min="1"
                              max="28"
                              defaultValue="10"
                            />
                            {errors.royalties?.[index]?.paymentDay && (
                              <small className="text-danger">
                                {errors.royalties[index].paymentDay.message}
                              </small>
                            )}
                          </div>
                          <div className="col-md-12">
                            <label className="form-label">Remark</label>
                            <textarea
                              {...register(`royalties.${index}.remark`)}
                              className="form-control"
                              rows="2"
                            ></textarea>
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* <div className="alert alert-info mt-2">
                                        <strong>Net Fee:</strong> {watch("netFeeAfterDiscount") || 0} | 
                                        <strong> Installment Total:</strong> {
                                            (watch("paymentInstallments") || []).reduce((sum, inst) => 
                                                sum + (parseFloat(inst.amount) || 0), 0
                                            ).toFixed(2)
                                        } | 
                                        <strong> Remaining:</strong> {
                                            (parseFloat(watch("netFeeAfterDiscount") || 0) - 
                                            (watch("paymentInstallments") || []).reduce((sum, inst) => 
                                                sum + (parseFloat(inst.amount) || 0), 0)).toFixed(2)
                                        }
                                    </div> */}
                    {renderStepActions("payment", "campus", "salesperson")}
                  </div>
                )}

                {activeTab === "salesperson" && (
                  <div>
                    <h5 className="mb-3 fs-9 border-bottom pb-2">
                      5. Salesperson Information
                    </h5>
                    {renderSalespersonDropdown()}

                    {salespersonFields.map((item, index) => (
                      <div
                        className="border rounded p-3 mb-3 position-relative"
                        key={item.id}
                        style={{ background: "#f9fafb" }}
                      >
                        <div className="row g-3">
                          <input
                            type="hidden"
                            {...register(`salespeople.${index}.salespersonId`)}
                          />
                          <div className="col-md-3">
                            <label className="form-label">
                              Salesperson
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              {...register(
                                `salespeople.${index}.salespersonName`
                              )}
                              className="form-control"
                              readOnly
                              style={{ backgroundColor: "#e9ecef" }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Franchise Fee Contribution
                              <span className="text-danger fs-9">*</span>
                            </label>
                            <input
                              type="number"
                              {...register(
                                `salespeople.${index}.franchiseFeeContribution`,
                                { required: "This field is required." }
                              )}
                              className="form-control"
                              step="0.01"
                            />
                            {errors.salespeople?.[index]
                              ?.franchiseFeeContribution && (
                              <small className="text-danger">
                                {
                                  errors.salespeople[index]
                                    .franchiseFeeContribution.message
                                }
                              </small>
                            )}
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Monthly Royalty — Amount
                            </label>
                            <input
                              type="number"
                              {...register(
                                `salespeople.${index}.monthlyRoyaltyAmount`
                              )}
                              className="form-control"
                              step="0.01"
                              onChange={(e) => {
                                if (e.target.value)
                                  setValue(
                                    `salespeople.${index}.monthlyRoyaltyPercentage`,
                                    ""
                                  );
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              Monthly Royalty — Percentage
                            </label>
                            <input
                              type="number"
                              {...register(
                                `salespeople.${index}.monthlyRoyaltyPercentage`
                              )}
                              className="form-control"
                              step="0.01"
                              onChange={(e) => {
                                if (e.target.value)
                                  setValue(
                                    `salespeople.${index}.monthlyRoyaltyAmount`,
                                    ""
                                  );
                              }}
                            />
                          </div>
                          <div className="col-md-3">
                            <label className="form-label">
                              W.Tax Deduction (%)
                            </label>
                            <input
                              type="number"
                              {...register(
                                `salespeople.${index}.withholdingTaxPercent`
                              )}
                              className="form-control"
                              step="0.01"
                            />
                          </div>
                          <div className="col-md-9">
                            <label className="form-label">
                              Terms & Conditions
                            </label>
                            <textarea
                              {...register(
                                `salespeople.${index}.termsAndConditions`
                              )}
                              className="form-control"
                              rows="2"
                            ></textarea>
                          </div>
                          <div className="col-12 d-flex justify-content-end gap-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => moveSalesperson(index, index - 1)}
                              disabled={index === 0}
                            >
                              ↑
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-outline-secondary"
                              onClick={() => moveSalesperson(index, index + 1)}
                              disabled={index === salespersonFields.length - 1}
                            >
                              ↓
                            </button>
                            <button
                              type="button"
                              className="btn btn-sm btn-danger"
                              onClick={() => removeSalesperson(index)}
                            >
                              ✕ Remove
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}

                    <div className="card mt-3">
                      <div className="card-header bg-light">
                        <h6 className="mb-0">Summary</h6>
                      </div>
                      <div className="card-body">
                        <div className="row g-3">
                          <div className="col-md-4">
                            <label className="form-label">
                              Total Franchise Fee Contribution
                            </label>
                            <input
                              type="text"
                              value={totals.totalFee}
                              className="form-control"
                              readOnly
                              style={{ backgroundColor: "#e9ecef" }}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Total Monthly Royalty (Amount)
                            </label>
                            <input
                              type="text"
                              value={totals.totalRoyaltyAmt}
                              className="form-control"
                              readOnly
                              style={{ backgroundColor: "#e9ecef" }}
                            />
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Average Monthly Royalty (%)
                            </label>
                            <input
                              type="text"
                              value={totals.avgRoyaltyPct}
                              className="form-control"
                              readOnly
                              style={{ backgroundColor: "#e9ecef" }}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    {renderStepActions("salesperson", "payment", "attachments")}
                  </div>
                )}

                {activeTab === "attachments" && (
                  <div>
                    <h5 className="mb-3 fs-9 border-bottom pb-2">
                      6. Attachments
                    </h5>

                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <p className="mb-0 text-muted">
                        Upload documents (CNIC, Cheques, Agreements, etc.)
                      </p>
                      <button
                        type="button"
                        className="btn btn-sm btn-primary"
                        onClick={addAttachment}
                      >
                        <i className="fas fa-plus me-1"></i> Add Attachment
                      </button>
                    </div>

                    {/* New Attachments Form */}
                    {attachmentFields.map((attachment, index) => (
                      <div
                        className="border rounded p-3 mb-3 position-relative"
                        key={attachment.id}
                      >
                        <button
                          type="button"
                          className="btn-close position-absolute top-0 end-0 m-2"
                          onClick={() => removeAttachment(index)}
                        ></button>
                        <div className="row g-3">
                          <div className="col-md-3">
                            <label className="form-label">Type</label>
                            <select
                              className="form-control"
                              value={attachment.attachmentType}
                              onChange={(e) =>
                                updateAttachmentField(
                                  index,
                                  "attachmentType",
                                  e.target.value
                                )
                              }
                            >
                              <option value="">Select Type</option>
                              <option value="Owner CNIC Front">
                                Owner CNIC Front
                              </option>
                              <option value="Owner CNIC Back">
                                Owner CNIC Back
                              </option>
                              <option value="Partner CNIC Front">
                                Partner CNIC Front
                              </option>
                              <option value="Partner CNIC Back">
                                Partner CNIC Back
                              </option>
                              <option value="Cheque Image">Cheque Image</option>
                              <option value="MOU Document">MOU Document</option>
                              <option value="Signed MOU">Signed MOU</option>
                              <option value="Partnership Deed">
                                Partnership Deed
                              </option>
                              <option value="Rental Agreement">
                                Rental Agreement
                              </option>
                              <option value="Other">Other</option>
                            </select>
                          </div>
                          <div className="col-md-4">
                            <label className="form-label">
                              Title/Description
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="e.g., Owner CNIC Front - Mr. Ali"
                              value={attachment.attachmentTitle}
                              onChange={(e) =>
                                updateAttachmentField(
                                  index,
                                  "attachmentTitle",
                                  e.target.value
                                )
                              }
                            />
                          </div>
                          <div className="col-md-5">
                            <label className="form-label">Upload File</label>
                            <input
                              type="file"
                              className="form-control"
                              onChange={(e) =>
                                updateAttachmentField(
                                  index,
                                  "file",
                                  e.target.files[0]
                                )
                              }
                            />
                          </div>
                        </div>
                      </div>
                    ))}

                    {/* Existing Attachments */}
                    {existingAttachments.length > 0 && (
                      <div className="mt-4">
                        <h6 className="mb-3 border-bottom pb-2">
                          Uploaded Attachments
                        </h6>
                        <div className="table-responsive">
                          <table className="table table-sm table-bordered">
                            <thead className="table-light">
                              <tr>
                                <th>Type</th>
                                <th>Title</th>
                                <th>File</th>
                                <th>Uploaded</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {existingAttachments.map((att) => (
                                <tr key={att.id}>
                                  <td>
                                    <span className="badge bg-secondary">
                                      {att.attachmentType}
                                    </span>
                                  </td>
                                  <td>{att.attachmentTitle}</td>
                                  <td>
                                    <a
                                      href={`${Url}${att.filePath}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <i className="fas fa-file me-1"></i>
                                      {att.fileName}
                                    </a>
                                  </td>
                                  <td>
                                    {new Date(
                                      att.uploadedOn
                                    ).toLocaleDateString()}
                                  </td>
                                  <td>
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-danger"
                                      onClick={() => deleteAttachment(att.id)}
                                    >
                                      <i className="fas fa-trash"></i>
                                    </button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}

                    {/* Actions */}
                    <div className="wizard-actions mt-4 d-flex justify-content-between">
                      <div>
                        <button
                          type="button"
                          className="btn btn-outline-secondary me-2"
                          onClick={() => setActiveTab("salesperson")}
                        >
                          Back
                        </button>
                      </div>
                      <div>
                        <button
                          type="button"
                          className="btn btn-success me-2"
                          onClick={saveAttachmentsStep}
                          disabled={stepSavingStates.attachments}
                        >
                          {stepSavingStates.attachments
                            ? "Saving..."
                            : "Save Attachments"}
                        </button>

                        {currentFranchiseId > 0 &&
                          !isReviewMode &&
                          !isReviewApproved &&
                          !isFinallyCompleted && (
                            <button
                              type="button"
                              className="btn btn-warning me-2"
                              onClick={handleStartReview}
                            >
                              <i className="fas fa-eye me-1"></i> Start Review
                            </button>
                          )}

                        {isReviewMode &&
                          !isReviewApproved &&
                          !isFinallyCompleted && (
                            <button
                              type="button"
                              className="btn btn-info"
                              onClick={handleReviewAndApprove}
                            >
                              <i className="fas fa-check-double me-1"></i>{" "}
                              Review & Approve
                            </button>
                          )}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </div>
      </div>

      {isModalVisible && (
        <DropdownWithCustomValuesModal
          dropdownName={modalModuleName}
          onClose={() => {
            setModalVisible(false);
            switch (modalModuleName) {
              case "region":
                fetchCommonSettings("region", setRegionData);
                break;
              case "city":
                fetchCommonSettings("city", setCityData);
                break;
              case "schoolCategory":
                fetchCommonSettings("schoolCategory", setSchoolCategoryData);
                break;
              case "franchiseCampusType":
                fetchCommonSettings("franchiseCampusType", setNewConvertedData);
                break;
              case "franchiseCampusOwnership":
                fetchCommonSettings(
                  "franchiseCampusOwnership",
                  setRentalOwnedData
                );
                break;
              case "salesperson":
                fetchCommonSettings("salesperson", setSalespersonData);
                break; // NEW
              case "royaltyCalculationType":
                fetchCommonSettings(
                  "royaltyCalculationType",
                  setRoyaltyCalculationTypeData
                );
                break; // NEW
              default:
                break;
            }
          }}
        />
      )}
    </>
  );
}

export default FranchiseOnboardingForm;
